let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8swDj")).then(() => parcelRequire('4Y3yO'));